import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initSuiteAppearance } from "@fg/ui-theme";
import { App } from "./App";
import { oidcConfig } from "@/auth/authConfig";
import "./styles/globals.css";

const queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } }
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found in index.html");

// Suite look (mode, accent, top-bar style) — this app's own look, else the
// suite's — applied before the first render and kept in step with other apps.
initSuiteAppearance("sheets");

ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
        <AuthProvider {...oidcConfig}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </AuthProvider>
    </React.StrictMode>
);
